<template>
  <v-text-field
    v-on="computedListeners"
    v-bind="computedProps"
    label=""
    outlined
    hide-details="auto"
    :placeholder="phtext"
    :tabindex="readonly ? -1 : 0"
    @dblclick="setCurrentDate()"
    dense
  />
</template>
<script>
import { VTextField } from 'vuetify/lib'
import inputMixin from '@/mixins/inputMixins'
import controls from '@/rahmen/controls'
import complements from '@/rahmen/complement'
import validators from '@/rahmen/validators'

import date from '@/ddv2.library/date'

/**
 * @file DDv2用日付入力
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [max='']- 許容最大値(デフォルト:2999/12/31)
 * @vue-prop {String} [min=''] - 許容最小値(デフォルト:2000/01/01)
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-date-box
    label="適用開始日"
    v-model="dateValue"
    max="2099/12/31"
    min="2000/01/01"/>
 */
export default {
  name: 'DdDateBoxInside',
  extends: VTextField,
  components: {
  },
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能最大値
     */
    max: String,
    /**
     * 入力可能最小値
     */
    min: String,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String
  },
  data: () => ({
    phtext: '',
    hasFocus: false,
    invalidMessage: '',
    innerValue: '',
    calendarDate: '',
    defaultMax: '2999/12/31',
    defaultMin: '2000/01/01'
  }),
  created () {
  },
  mounted () {
    const dtl = controls.getInputTypeDetail(controls.InputTypes.Date)
    if (!dtl) { return }
    this.phtext = !this.readonly ? dtl.placeholder.replace('@@length@@', this.length) : ''
    this.invalidMessage = this.errorMessages
    this.innerValue = this.value
  },
  watch: {
    value: function (n, o) {
      this.innerValue = n
    }
  },
  computed: {
    calendarMax () {
      if (this.max) {
        return this.max.split('/').join('-')
      }
      return undefined
    },
    calendarMin () {
      if (this.min) {
        return this.min.split('/').join('-')
      }
      return undefined
    },
    computedProps () {
      return {
        ...this.$props,
        value: this.innerValue,
        maxlength: this.length,
        class: (this.required ? ' required-item' : this.class),
        hideDetails: 'auto',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== undefined
    }
  },
  methods: {
    onBlur: function (e) {
      this.complement()
      if (!this.isShowCalendar) {
        this[controls.VALIDATE_METHOD]()
      }
      if (!this.hasError) {
        // this[controls.FORMAT_METHOD]()
      }
    },
    onFocus: function (e) {
      const val = this.lazyValue
      if (this.lazyValue !== null && this.lazyValue !== '' && this.lazyValue !== undefined) {
        this.innerValue = val.split('/').join('')
      }
      const elem = this.$el.querySelector('input')
      console.log('DdDateBox.onFocus', elem)
      this.$nextTick().then(() => {
        if (elem) { elem.select() }

        /**
         * フォーカス設定
         * @event focus
         * @type {Event}
         */
        this.$emit('focus', e)
      })
    },
    complement: function () {
      const val = complements.parseDate(this.lazyValue)
      this.$set(this, 'innerValue', val)
      /**
       * 補完値input
       * @event input
       * @type {Event}
       */
      this.$emit('input', val)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        max: this.max === undefined ? this.defaultMax : this.max,
        min: this.min === undefined ? this.defaultMin : this.min
      }
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(controls.InputTypes.Date)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    },
    setCurrentDate: function () {
      if (this.readonly) return

      console.log('setCurrentDate')
      if ([undefined, null, ''].includes(this.innerValue)) {
        this.innerValue = date.getCurrentDate()
        this.$emit('input', this.innerValue)
        this[controls.VALIDATE_METHOD]()
      }
      this.isShowCalendar = false
    }
  }
}
</script>
<style scoped>
.v-picker.v-card.v-picker--date {
  position: absolute;
  z-index: 500;
}
.mdi-calendar::before {
  color: #2196F3;
}
.v-menu__content.theme--light {
  width: 290px !important;
  height: 336px !important;
}
::v-deep .v-input__control>.v-input__slot {
  border: 1px solid transparent !important;
  color: transparent !important;
}
::v-deep .v-input__control>.v-input__slot fieldset{
  border: 1px solid transparent !important;
}
::v-deep .v-input__control>.v-input__slot fieldset{
  background-color: transparent !important;
}
</style>
